/**
 * EmptyState — bloc d'état vide générique (affichage pur).
 *
 * Titre + sous-titre + jusqu'à deux actions (principale, secondaire). Aucune
 * logique métier ni droit ici : le parent décide des textes et ne passe une
 * action que si l'utilisateur y a droit. Promu dans shared/ quand l'écran
 * Importer est devenu le 2ᵉ consommateur hors de horses/ (D52, D39).
 *
 * @param {{ label: string, onClick: Function, Icon?: React.ComponentType }} [primaryAction]
 * @param {{ label: string, onClick: Function, Icon?: React.ComponentType }} [secondaryAction]
 */
import React from 'react';
import { getTheme, BTN } from '../constants/theme';

const ActionButton = ({ action, style }) => {
  const { label, onClick, Icon } = action;
  return (
    <button type="button" onClick={onClick} style={style}>
      {Icon && <Icon size={16} />} {label}
    </button>
  );
};

const EmptyState = ({ title, subtitle, primaryAction, secondaryAction, darkMode }) => {
  const t = getTheme(darkMode);
  const hasActions = Boolean(primaryAction || secondaryAction);
  return (
    <div style={{ textAlign: 'center', padding: '20px 24px', color: t.textSecondary }}>
      <p style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600' }}>{title}</p>
      <p style={{ fontSize: '14px' }}>{subtitle}</p>
      {hasActions && (
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '16px' }}>
          {primaryAction && <ActionButton action={primaryAction} style={BTN.primary} />}
          {secondaryAction && <ActionButton action={secondaryAction} style={BTN.secondary(darkMode)} />}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
